import { AsyncPipe, DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { Observable, Subscription, fromEvent } from 'rxjs';

import { AuthService } from '@services/auth/auth.service';
import { SessionExpireService } from '@services/session-expire-service/session-expire.service';

@Component({
  selector: 'app-session-expires',
  templateUrl: './session-expires.component.html',
  styleUrls: ['./session-expires.component.scss'],
  imports: [AsyncPipe, DatePipe],
})
export class SessionExpiresComponent implements OnInit, OnDestroy {
  timeRemaining: any;
  seconds: number;

  onClickObservable: Observable<Event> = fromEvent(document, 'click');
  onKeyDownObservable: Observable<Event> = fromEvent(document, 'keydown');

  private subscription: Subscription;

  constructor(
    private authService: AuthService,
    private sessionExpireService: SessionExpireService
  ) {
    this.seconds = sessionExpireService.getExpirationTime() / 1000; // This is needed to convert milliseconds to seconds;
    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.startSessionExpiredTimer();

    this.sessionExpireService.updateTimeRemaining$.subscribe(timeRemaining => {
      if (timeRemaining) {
        this.timeRemaining = this.sessionExpireService.updateExpirationTime(timeRemaining);
      }
    });
  }

  private startSessionExpiredTimer(): void {
    if (!this.timeRemaining) {
      this.timeRemaining = this.sessionExpireService.updateExpirationTime(this.seconds);
    }

    if (this.authService.isAuthenticated()) {
      this.sessionExpireService.setExpirationTime();
      this.timeRemaining = this.sessionExpireService.updateExpirationTime(this.seconds);
    }

    this.subscription.add(
      this.onClickObservable.subscribe(() => {
        // if(this.authService.isAuthenticated()) {
        if (!this.sessionExpireService.isModalVisible$.value) {
          this.sessionExpireService.setExpirationTime();
          this.timeRemaining = this.sessionExpireService.updateExpirationTime(this.seconds);
        }
        // }
      })
    );

    this.subscription.add(
      this.onKeyDownObservable.subscribe(() => {
        // if(this.authService.isAuthenticated()) {
        if (!this.sessionExpireService.isModalVisible$.value) {
          this.sessionExpireService.setExpirationTime();
          this.timeRemaining = this.sessionExpireService.updateExpirationTime(this.seconds);
        }
        // }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
